// CB:BEGIN admin-layout-mvp-styling
import React from 'react';
import RequireAdmin from './RequireAdmin';
import { Outlet } from 'react-router-dom';

interface AdminLayoutProps {
  children?: React.ReactNode;
  currentScreen?: string;
  onNavigate?: (screen: string) => void;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children, currentScreen = 'admin-dashboard', onNavigate }) => {

  return (
    <RequireAdmin onNavigate={onNavigate}>
      <div className="min-h-screen bg-gray-50">
        {/* Main Content */}
        <main>
          <div className="max-w-7xl mx-auto px-6 py-6">
            {children || <Outlet />}
          </div>
        </main>
      </div>
    </RequireAdmin>
  );
};

export default AdminLayout;
// CB:END admin-layout-mvp-styling
